var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 500,
    id: "svg2",
    width: 500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-552.36218)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 500,
    id: "rect2990-1",
    rx: 250,
    ry: 250,
    style: {
      fill: "#0077b5",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 500,
    x: 0,
    y: 552.36218
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1-9",
    transform: "translate(-549.00515,80.294372)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer1-6",
    transform: "translate(-575.71429,39.999999)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "layer1-92",
    transform: "matrix(0.99533037,0,0,0.99716768,619.96997,-73.128637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1-9-7",
    transform: "translate(-1068,-236)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 128.76316,642.36224 C 107.34952,642.36224 90,659.75123 90,681.20435 c 0,21.45322 17.34952,38.8421 38.76316,38.8421 21.41364,0 38.76316,-17.38888 38.76316,-38.8421 0,-21.45312 -17.34952,-38.84211 -38.76316,-38.84211 z m 203.02631,101.13158 0,0.0263 c -4.37833,-0.0156 -8.62646,0.15968 -14.18421,0.44737 -12.18891,0.63097 -40.6558,13.83786 -51.07894,34.92106 0,-9.15329 0.10526,-17.55993 0.10526,-30.10527 -12.4852,0 -28.82418,0.0789 -62.94737,0.0789 0,38.30812 -0.42105,173.97085 -0.42105,213.5 l 66.07895,0 c 0,-23.44978 0.31578,-82.35285 0.31578,-119.34211 0,-12.42047 7.50808,-41.10526 38.31579,-41.10526 27.97383,0 35.81579,23.57737 35.81579,41.10526 0,38.52259 -0.28947,92.97632 -0.28947,119.34211 l 66.47368,0 c 0,-25.77235 0.23633,-95.77893 -0.55263,-139.94737 -0.95794,-53.62831 -33.53337,-76.50988 -62.76316,-78.31579 -6.01505,-0.37149 -10.49009,-0.5893 -14.86842,-0.60526 z m -236.210523,6.21053 0,212.55263 66.263163,0 0,-212.55263 -66.263163,0 z",
    id: "rect2989-1-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedn);
export default __webpack_public_path__ + "static/media/linkedn.b97a02fcbdf680a481481f3ce4637acd.svg";
export { ForwardRef as ReactComponent };